import useSettingsStore from "views/hooks/useSettingsStore";
import { useLocation, useParams } from "react-router-dom";
import useFooterStore from "views/hooks/useFooterStore";
import { FaSave, FaArrowLeft } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { Button } from "antd";
import { routes } from "config/routes";

interface FooterPropsTypes {
  menu?: string;
}

export default function Footer(props: FooterPropsTypes): React.ReactElement {
  const urlParams: RouteParams = useParams();
  const { menu } = props;

  const location = useLocation();
  const lastString = location.pathname.split("/").pop();

  const hideBySubMenu = [
    "vats",
    "vats-type",
    "sales",
    "clientAddress",
    "payments",
    "attachments",
    "payment",
    "debits",
    "comments",
    "template",
    "products",
    "categories",
    "product-type",
    "paymentDateLimit",
    "client-payments",
    "client-address",
    "client-phones",
    "client-emails",
    "client-banks",
    "client-contacts",
    "client-balance",
    "client-documents",
    "export-history",
  ].includes((lastString || urlParams?.subMenu) ?? "");

  const hideByMenu = ["clients", "payment", "debits"]?.includes(urlParams.menu ?? "");

  const isUpdateView =
    urlParams?.productId ||
    (urlParams?.clientId &&
      urlParams?.subMenu !== "client-address" &&
      urlParams?.subMenu !== "client-payments" &&
      urlParams?.subMenu !== "client-contacts");

  const setHandleOkSaveButton = useFooterStore(state => state.setHandleOkSaveButton);
  const canExport = useSettingsStore(state => state.canExport);
  const saveLoading = useFooterStore(state => state.saveLoading);

  const { t } = useTranslation();

  const shouldShowFooter = (!hideBySubMenu && !hideByMenu) || isUpdateView || !canExport;

  if (!shouldShowFooter || hideBySubMenu) {
    return <></>;
  }

  const hasGoBack = !!urlParams?.clientId;

  if (!hasGoBack) {
    return (
      <div className="floating-save">
        <Button
          type="primary"
          loading={saveLoading}
          onClick={() => setHandleOkSaveButton(true)}
          onMouseLeave={e => e.currentTarget.blur()}
          icon={<FaSave />}
          className="floating-save__button"
        >
          {t("Save")}
        </Button>
      </div>
    );
  }

  return (
    <div className="floating-footer">
      <Button
        className="floating-footer__button floating-footer__button--back"
        onClick={() => {
          routes.navigate(`/company/${urlParams.companyId}/${menu || "dashboard"}`);
        }}
        icon={<FaArrowLeft />}
      >
        {t("Go back")}
      </Button>
      <div className="floating-footer__divider" />
      <Button
        type="primary"
        loading={saveLoading}
        onClick={() => setHandleOkSaveButton(true)}
        onMouseLeave={e => e.currentTarget.blur()}
        icon={<FaSave />}
        className="floating-footer__button floating-footer__button--save"
      >
        {t("Save")}
      </Button>
    </div>
  );
}
